<template>
  <div>
    <!--统计行-->
    <ak-model-count-group :options="options" />
    <!--图表行-->
    <ak-model-chart
      class="m-t-24"
      title="用户新增趋势"
      :options="chartOptions1"
    />
  </div>
</template>
<script>
export default {
  data () {
    return {
      options: [
        {
          model: 'user',
          icon: 'user',
          note: '用户'
        },
        {
          model: 'indexFac',
          icon: 'mobile',
          note: '设备'
        },
        {
          model: 'feedback',
          icon: 'message'
          // note: '意见反馈'
        }
      ],
      chartOptions1: [
        {
          model: 'user',
          chartType: 'bar', // 图表类型，可选值：line 折线图，bar 柱状图
          name: '新增用户',
          color: '#E6650A' // 可选，自定义颜色
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
</style>
